/** @jsx jsx */
import { Button } from 'components/buttons/Button'
import { jsx, Text, Box } from 'theme-ui'

const MapButton = ({
  selected,
  onClick,
  variant = 'smallCopySmallCapsClearReverse',
  color = 'black',
  style = 'icon',
  ...props
}) => {
  return (
    <Button sx={{ position: 'relative' }} {...props} onClick={onClick}>
      {/* {style === 'icon' || style === 'textandicon' ? (
        <SavedIcon saved={favourites[id]} iconColor={iconColor} />
      ) : null} */}
      <Box
        variant={`smallCopySmallCapsReverse`}
        sx={{
          position: 'absolute',
          bottom: ['3px', null, null, '4px', '5px'],
          left: '0',
          // [0, null, null, 1, 2]
          height: ['8px', null, null, '10px', '10px'],
          width: ['8px', null, null, '10px', '10px'],
          border: '0px solid',
          borderColor: color === 'red' ? 'black' : 'red',
          transition: '0.2s background-color',
          overflow: 'hidden',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {/* 'X' graphic */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 64 64"
          sx={{
            display: 'block',
            stroke: color === 'red' ? 'black' : 'red',
            fill: color === 'red' ? 'black' : 'red',
            strokeWidth: `${selected ? '10px' : '0px'}`,
            width: '100%',
            height: '100%',
            border: '1px solid',
            borderColor: 'red',
          }}
        >
          <title>Selected</title>
          <path d="M64 64 L0 0" />
          <path d="M64 0 L0 64" />
        </svg>
      </Box>
      <Text variant={'smallCopySmallCapsReverse'} ml={'0.8em'}>
        {props.children}
      </Text>
    </Button>
  )
}

export { MapButton }

{
  1
  /* <svg
          xmlns="http://www.w3.org/2000/svg"
          width="8.962"
          height="10.434"
          viewBox="0 0 8.962 10.434"
        >
          <path
            id="Path_33"
            data-name="Path 33"
            d="M0,0V9L3.977,6.353,7.962,9V0Z"
            transform="translate(0.5 0.5)"

            strokeWidth="1"
          />
        </svg> */
}
